import React from 'react';
import './Button.css';

const ButtonModelField = ( props ) => {
    let btnCls = 'btn btn-outline-primary btn-rounded waves-effect';
    btnCls = (props.color == 'danger') ? 'btn btn-outline-danger btn-rounded waves-effect' : 'btn btn-outline-primary btn-rounded waves-effect';
    return(
        <div>
            <button
            style={{
                borderRadius: '15px',
                width:'13%',
                float:'right',
                marginRight: '5%', }}
                className= { btnCls }
                onClick={props.submit}
                disabled={props.disabled}
            >
                {props.BName}
            </button>
        </div>
    );
}

export default ButtonModelField;